import { tv } from 'tailwind-variants';

import { EntitySection } from './entity-section.component';

import { Skeleton } from '@/components/ui/skeleton.component';

const titleSkeletonClasses = tv({
  base: ['w-48 h-5'],
});

function TextSkeleton({ className }: { className?: string }) {
  return <Skeleton className={titleSkeletonClasses({ className })} />;
}

export function ListSkeleton() {
  return (
    <div className="space-y-3 mt-5 w-full">
      {Array.from({ length: 3 }).map((_, i) => (
        <div className="flex items-center gap-3 w-full" key={i}>
          <Skeleton className="w-2 h-2 rounded-full" />
          <TextSkeleton className="h-3" />
        </div>
      ))}
    </div>
  );
}

export function EntityAboutLoading() {
  return (
    <div className="mt-10">
      <div className="flex items-center justify-evenly">
        <Skeleton className="w-20 h-5" />
        <Skeleton className="w-20 h-5" />
      </div>
      <hr className="mt-7" />
      <EntitySection>
        <TextSkeleton />

        <div className="space-y-3 mt-5 w-full">
          {Array.from({ length: 3 }).map((_, i) => (
            <div className="flex items-start gap-3 w-full" key={i}>
              <Skeleton className="w-6 h-6 rounded" />
              <div className="w-full space-y-2">
                <TextSkeleton />
                <TextSkeleton className="h-4 w-3/4" />
              </div>
            </div>
          ))}
        </div>
      </EntitySection>

      <EntitySection>
        <TextSkeleton />

        <div className=" mt-5 w-full">
          <TextSkeleton className="w-full h-3" />
        </div>
      </EntitySection>

      <EntitySection>
        <TextSkeleton />

        <div className=" mt-5 w-full">
          <ListSkeleton />
        </div>
      </EntitySection>

      <EntitySection>
        <TextSkeleton />

        <div className=" mt-5 w-full">
          <ListSkeleton />
        </div>
      </EntitySection>

      <EntitySection>
        <TextSkeleton />

        <div className=" mt-5 w-full">
          <ListSkeleton />
        </div>
      </EntitySection>
    </div>
  );
}
